<template lang="pug">
  y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550 content-class="round-2xl")
    v-card
      v-card-title.px-4
        v-spacer
        .text-lg.font-bold Redeem reward
        v-spacer
      v-divider
      div.py-6.px-8
        template(v-if="step === 0")
          reward-to-redeem(v-model="rewardToRedeem" :member.sync="selectedMember" :collectedValue="collectedValue" :rewardsPosition="rewardsPosition" :availableRewards="availableRewards" :loyaltySystem="loyaltySystem" :memberSelectable="memberSelectable")
        template(v-if="step === 1")
          redeem-verification-code(v-model="otp" itemText="reward")
        template(v-if="step === 2")
          redeem-reward-finish(:member="selectedMember" :redeemedReward="rewardToRedeem")
      v-divider
      v-card-actions.px-6
        v-spacer
        v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('cancel') }}
        v-btn.button-md.neutral700.white--text(v-if="step === 2" depressed @click="closeDialog") {{ $t('finish') }}
        v-btn.button-md.neutral700.white--text(v-else :loading="isLoading" depressed :disabled="isDisabledContinue" @click="handleContinue") Redeem
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import RewardToRedeem from "@/components/clinic/checkout/marketing/redeem/reward/RewardToRedeem.vue";
import RedeemVerificationCode from "@/components/clinic/checkout/marketing/redeem/RedeemVerificationCode.vue";
import RedeemRewardFinish from "@/components/clinic/checkout/marketing/redeem/reward/RedeemRewardFinish.vue";
import clone from "just-clone";

export default {
  components: {
    RedeemRewardFinish,
    RedeemVerificationCode,
    RewardToRedeem,
  },
  props: {
    open: {
      type: Boolean,
    },
    member: {
      type: Object,
      required: true
    },
    rewardsPosition: {
      type: Array,
      default: () => ([])
    },
    loyaltySystem: {
      type: String,
      required: true
    },
    memberSelectable: {
      type: Boolean,
    }
  },
  data() {
    return {
      step: 0,
      otp: null,
      isLoading: false,
      rewardToRedeem: null,
      selectedMember: null
    }
  },
  mounted() {
    if (this.member) {
      this.selectedMember = clone(this.member)
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    isDisabledContinue() {
      if (this.step === 0) {
        return !this.rewardToRedeem
      }
      if (this.step === 1) {
        return !this.otp || this.otp.toString().length !== 4
      }
      return false
    },
    otpRequestPayload() {
      return {
        phone: this.member.phone,
        event: 'loyalty reward'
      }
    },
    otpCheckPayload() {
      return {
        phone: this.member.phone,
        otp: `${this.otp}`
      }
    },
    redeemRewardPayload() {
      return {
        reward: this.rewardToRedeem?.id,
        type: 'rewards',
      }
    },
    collectedValue() {
      return this.selectedMember?.collected || 0
    },
    availableRewards() {
      return this.selectedMember?.available_rewards || []
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    closeDialog() {
      this.$emit('closed')
      this.showDialog = false
    },
    async handleContinue() {
      if (this.step === 0) {
        const requested = await this.requestOTP()
        if (!requested) return
        this.step = 1
        return
      }
      if (this.step === 1) {
        const isValidOTP = await this.checkOTP()
        if (!isValidOTP) return
        const redeemed = await this.redeemReward()
        this.refetch()
        if (!redeemed) return
        this.step = 2
      }
    },
    async requestOTP() {
      try {
        this.isLoading = true
        const url = `/marketing/${this.company.slug}/redeems/request_otp`
        const {data} = await this.$axios.post(url, this.otpRequestPayload)
        this.updateActivityLog(url, this.otpRequestPayload, data, 'POST', 'Redeem reward request OTP', null)
        return true
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        return false
      } finally {
        this.isLoading = false
      }
    },
    async checkOTP() {
      const url = `/marketing/${this.company.slug}/redeems/check_otp`
      try {
        this.isLoading = true
        const {data} = await this.$axios.post(url, this.otpCheckPayload)
        this.updateActivityLog(url, this.otpCheckPayload, data, 'POST', 'Redeem reward check OTP - success')
        return true
      } catch (error) {
        if (error.response.status === 400) {
          this.updateActivityLog(url, this.otpCheckPayload, error.response.data, 'POST', 'Redeem reward check OTP - invalid TAC')
          this.showMessage(['error', 'Invalid TAC'])
        } else {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        }
        return false
      } finally {
        this.isLoading = false
      }
    },
    async redeemReward() {
      try {
        const url = `/loyalty/${this.company.slug}/members/${this.member.id}/collects`
        const {data} = await this.$axios.post(url, this.redeemRewardPayload)
        this.updateActivityLog(url, this.redeemRewardPayload, data, 'POST', 'Redeem loyalty reward', data.id)
        return true
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        return false
      }
    },
    updateActivityLog(endpoint, payload, response, method, activity, id, objectRef) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: objectRef || null,
        activity: activity,
        raw_data: {endpoint, payload, response: response, method}
      }
      this.$axios.post('/users/logs', data)
          .catch(() => {
          })
    },
    refetch() {
      this.$emit('refetch')
    }
  },
}
</script>

<style scoped>
</style>